<script>
  import { LmsUtils } from '../../../../../LMS/utils/LmsUtils';
  import { External, M } from '../../../../../external';
  import { onMount } from 'svelte';

  export let activityType,
    data = { groupId: '' },
    contact;

  let circle;

  let clickHandler = async () => {
    if (circle) {
      External.CPanel.goToUrl(`/me/community/circles/${circle.url}`);
    }
  };

  onMount(async () => {
    let circles = await LmsUtils.listCircles();
    circle = circles.find((circle) => circle.id === data.groupId);
  });
</script>

<a class="blue-text" on:click={clickHandler}>
  {#if data.groupId === 'default'}
    {M.COMMUNITY}
  {:else if circle && circle.name}
    {circle.name}
  {/if}
</a>
